import React from "react";

import "./Application.css";
import { LoginPage } from "./pages/LoginPage";

export const Application = () => {
    return <LoginPage />;
};
